<template>
  <section id="wrapper" class="error-page">
    <div class="error-box">
      <div class="error-body text-center">
        <h1 class="text-info">Sorry</h1>
        <h3 class="text-uppercase">エラーが発生しました。</h3>
        <p class="text-muted m-t-30 m-b-30">ご迷惑をおかけして申し訳ありません。お時間をおいて後ほどアクセスしてください。</p>
        <a href="/" class="btn btn-info btn-rounded waves-effect waves-light m-b-40">ホームへ戻る</a>
      </div>
    </div>
  </section>
</template>

<script setup>
</script>

<style scoped>

</style>
